/**
 * WordPress dependencies.
 */
import { InnerBlocks, RichText } from '@wordpress/block-editor';
// import { useState } from '@wordpress/element';
import { Icon } from '@wordpress/components';

/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * Inner dependencies.
 */

export default function Save( props ) {
	const { className, attributes } = props;
	const { blockClientId } = attributes;
	const wrapperClasses = classnames(
		className,
		'gutenify-block-content-toggle-item-wrapper',
		`gutenify-section-${ blockClientId }`,
	);

	return (
		<div className={ wrapperClasses }>
			<div className={ `gutenify-content-toggle-item-wrapper ${ attributes.initialOpen ? 'gutenify-content-toggle-item-open' : 'gutenify-content-toggle-item-closed' }` }>
				<div className="gutenify-content-toggle-item-header">
					<RichText.Content { ...props } tagName="h4" value={ attributes.title } />
					<button className="gutenify-content-toggle-item-handle">
						<Icon icon="arrow-up-alt2" />
						<Icon icon="arrow-down-alt2" />
					</button>
				</div>
				<div className="gutenify-content-toggle-item-content"> <InnerBlocks.Content /> </div>
			</div>
		</div>

	);
}

